const binding = { modules: {}, dataActions: {} };

    (binding.modules['fabrikam'] = {
        c: () => require('@msdyn365-commerce-modules/fabrikam-design-kit/dist/lib/modules/fabrikam/fabrikam'),
        $type: 'themeModule',
        da: [],
        definitionExtensions: ['buybox','content-block','media-gallery','navigation-menu','promo-banner','text-block'],
        iNM: true,
        ns: '@msdyn365-commerce-modules',
        n: 'fabrikam',
        p: 'fabrikam-design-kit',
        
        pdp: '',
        
        themeSettings: 'fabrikam.theme.settings.json',
        md: 'node_modules/@msdyn365-commerce-modules/fabrikam-design-kit/dist/lib/modules/fabrikam'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };